<div class="response">
  <div class="response-header-m">
  <figure class="icon">
      <img *ngIf="approval.approval_status =='decline'" src="assets/icon-decline.png "  />
      <img *ngIf="approval.approval_status =='approve'" src="assets/icon-success.png "  />
  </figure>
  <figure class="preview" *ngIf="approval.files.length> 0">
      <core-preview-first [files]="approval.files" [format]="'small-width'"></core-preview-first>
  </figure>
</div>
  <div class="content">
      <div class="header">
        <core-helper-box-header-user-date
            *ngIf="approval.approval_status =='decline'"
            [preText]="'Version '+approval.version.version+' was rejected by '"
            [user]="approval.user"
            [date]="approval.date">
        </core-helper-box-header-user-date>
        <core-helper-box-header-user-date
            *ngIf="approval.approval_status =='approve'"
            [preText]="'Version '+approval.version.version+' was approved by '"
            [user]="approval.user"
            [date]="approval.date">
        </core-helper-box-header-user-date>
      </div>
      <div class="txt">
          <span class="" [innerHTML]="approval.message">{{approval.message}}</span>
      </div>
  </div>
</div>
